export const LoginIcon = () => (
  <svg width="30" height="30" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.858 11.3333C32.858 16.9764 27.9353 21.6667 21.7151 21.6667C15.495 21.6667 10.5723 16.9764 10.5723 11.3333C10.5723 5.69025 15.495 1 21.7151 1C27.9353 1 32.858 5.69025 32.858 11.3333Z" fill="white" stroke="black" strokeWidth="2"/>
    <path d="M41 40C41 29.6907 32.0457 21.3333 21 21.3333C9.95431 21.3333 1 29.6907 1 40" stroke="black" strokeWidth="2"/>
  </svg>
); 